/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Ai_PrInputs */

const en_fc_cmp_ai_pr = /** @type {(inputs: Fc_Cmp_Ai_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generative Extend, Object Mask, text-based editing, Enhance Speech`)
};

/**
* | output |
* | --- |
* | "Generative Extend, Object Mask, text-based editing, Enhance Speech" |
*
* @param {Fc_Cmp_Ai_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_ai_pr = /** @type {((inputs?: Fc_Cmp_Ai_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Ai_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_ai_pr(inputs)
});
export { fc_cmp_ai_pr as "fc.cmp.ai.pr" }